import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import AnchorLink from "react-anchor-link-smooth-scroll";
import styled from "styled-components";
// function Header() {
//   const Line = styled.div`
//     flex: 1;
//     height: 3px;
//     background: var(--primary-color);
//     opacity: 0.7;
//     max-width: 200px;
//   `;
//   const NavLink = styled(Nav.Link)`
//     color: var(--text-color);
//     &:hover {
//       color: var(--primary-color);
//     }

//     &.active {
//       color: var(--primary-color);
//     }
//   `;
//   return (
//     <div>
//       <Line />
//       <Navbar expand="lg" sticky="top">
//         <Container
//           style={{
//             backgroundColor: "var(--background-color)",
//             margin: 0,
//           }}
//         >
//           <Navbar.Brand
//             href="#home"
//             className="title"
//             style={{ padding: "0.5rem" }}
//           >
//             D
//           </Navbar.Brand>
//           <Navbar.Toggle aria-controls="basic-navbar-nav" />
//           <Navbar.Collapse
//             id="basic-navbar-nav"
//             style={{ display: "flex", justifyContent: "center" }}
//           >
//             <Nav>
//               <AnchorLink href="#home" style={{ textDecoration: "none" }}>
//                 <NavLink>Home</NavLink>
//               </AnchorLink>

//               <AnchorLink href="#Me" style={{ textDecoration: "none" }}>
//                 <NavLink>About Me</NavLink>
//               </AnchorLink>
//               <AnchorLink href="#Skills" style={{ textDecoration: "none" }}>
//                 <NavLink>Skills</NavLink>
//               </AnchorLink>
//               <AnchorLink href="#Projects" style={{ textDecoration: "none" }}>
//                 <NavLink>Projects</NavLink>
//               </AnchorLink>

//               <AnchorLink href="#Footer" style={{ textDecoration: "none" }}>
//                 <NavLink>Contact Me</NavLink>
//               </AnchorLink>
//             </Nav>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>
//     </div>
//   );
// }

function Header() {
  const StyledNavbar = styled(Navbar)`
    background-color: var(--background-color);
    padding: 0.75rem 1rem;
    justify-content: center;
  `;

  const NavWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 900px;
    justify-content: space-between;
    position: relative;
  `;

  const GradientLine = styled.div`
    height: 2px;
    background: linear-gradient(to right, var(--primary-color), #f2d2fa);
    flex: 1;
    margin: 0 1rem;
  `;

  const NavLink = styled(Nav.Link)`
    color: var(--text-color) !important;
    font-weight: 500;
    position: relative;
    transition: color 0.3s;

    &.active,
    &:hover {
      color: var(--primary-color) !important;
    }
  `;
  return (
    <StyledNavbar expand="md" variant="dark" collapseOnSelect>
      <Container
        fluid
        className="d-flex align-items-center justify-content-between"
      >
        <GradientLine />
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto text-center">
            <NavLink href="#Home">Home</NavLink>
            <NavLink href="#Me">About</NavLink>
            <NavLink href="#Skills">Skills</NavLink>
            <NavLink href="#Projects">Projects</NavLink>
            <NavLink href="#Footer">Contact</NavLink>
          </Nav>
        </Navbar.Collapse>
        <GradientLine />
      </Container>
    </StyledNavbar>
  );
}

export default Header;
